import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WizardStep } from '../../../../wizard/wizard.component';
import { OrderBatchLogisticsWizardService } from 'src/app/services/wizard/logistic/order-batch-send-wizard.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { OrderBatchItem } from '../../../../model/logistics/order/index';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-receive-order-logistics-item',
  templateUrl: './receive-order-logistics-item.component.html'
})
export class ReceiveOrderLogisticsItemComponent implements OnInit, WizardStep {

  form: FormGroup;
  loading: boolean;
  isInit: boolean;
  wasActivated: boolean;
  proNoAdded: string;
  proAdded: string;

  @ViewChild('newProtocol', {static: false}) newProtocol: ElementRef;
  displayColumns = ['select', 'Protocol'];
  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<OrderBatchItem>(true, []);
  noFindProtocols: string[] = [];
  constructor(private orderBatchSendWizardService: OrderBatchLogisticsWizardService
    , private notificationToastService: NotificationToastService
    , private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      NewProtocol: ['']
    });
  }

  ngOnInit(): void {
    this.isInit = true;
  }

  get valid(): boolean {
    return this.completed;
  }


  get completed(): boolean { return true; }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  activate(): void {
    if (!this.wasActivated) {
      const items = this.orderBatchSendWizardService.getOrderBatchItems();
      this.addItems(items);
      this.wasActivated = true;
    }
    setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
  }

  private addItems(items: OrderBatchItem[]) {
    this.dataSource = new MatTableDataSource(items);
    items.forEach((item) => {
        item.IsReceive = true;
        this.selection.select(item);
    });
  }

  private findProtocol(findProtocol: string, item: OrderBatchItem) {
    let find = false;
    const re = /\-/gi;
    findProtocol = findProtocol.replace(re, '');
    const protocol = item.Protocol.replace(re, '');
    find = protocol === findProtocol;
    return find;
  }

  save(): void {
    this.orderBatchSendWizardService.getOrderBatchItems().forEach((item) => {
      item.IsReceive = this.selection.isSelected(item);
    });
  }

  protocolNoAdded(): string {
    return this.proNoAdded;
  }

  protocolAdded(): string {
    return this.proAdded;
  }

  async addProtocol() {
    if (this.form.valid) {
      const items = this.orderBatchSendWizardService.getOrderBatchItems();
      const re = /\-/gi;
      const findProtocol = this.form.controls.NewProtocol.value.replace(re, '');
      let find = false;

      items.forEach((item) => {
        if (this.findProtocol(findProtocol, item)) {
          find = true;
          this.selection.select(item);
          this.proAdded = this.form.controls.NewProtocol.value;
          this.proNoAdded = null;
        }
      });

      if (!find) {
        this.notificationToastService.error('Protocolo NO encontrado', 'Recepción de órdenes');
        this.noFindProtocols.push(this.form.controls.NewProtocol.value);
        this.proAdded = null;
        this.proNoAdded = this.form.controls.NewProtocol.value;
      } else {
        this.notificationToastService.success('Protocolo encontrado', 'Recepción de órdenes');
      }

      this.form.patchValue({ NewProtocol: '' });
      setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
    }
  }
}
